import { draftFieldsFromLists, type DraftFields } from '@/features/messaging/useMessageDraftLifecycle';
import type { Content, MemberExternalAccountSafe } from '@vivport/backend/types';

const PROVIDER_LABEL: Record<MemberExternalAccountSafe['provider'], string> = {
  GOOGLE: 'Google',
  MICROSOFT: 'Microsoft',
};

export function describeAccount(account: MemberExternalAccountSafe): string {
  return `${account.externalEmail} (${PROVIDER_LABEL[account.provider] ?? account.provider})`;
}

export function readComposeDraftFields(content: Content): DraftFields | null {
  if (content.contentType !== 'MESSAGE') return null;
  const composeDraft = content.conversation?.composeDraft ?? null;
  return composeDraft === null ? null : draftFieldsFromLists(composeDraft);
}
